<template>
  <div class="sentence" role="tablist">

    <b-tabs pills card >
      <template v-slot:tabs-start>
      </template>
      <b-tab v-for="(s,i) in sentences" :key="'se'+i"
        :title="s.text">
        <template v-slot:title>
          {{s.text}}
        </template>
          <b-tabs content-class="mt-3" align="center">
            <b-tab title="CoNLL-U">
              <pre>{{s.conllu}}</pre>
            </b-tab>
            <b-tab title="Dependency Graph" active>
              <b-img
                v-img fluid
                v-for="graph in s.dependencyGraphs"
                :key="graph.id"
                :src="graph.url" />
            </b-tab>
            <b-tab title="Metadata">

              <b-list-group>
                <b-list-group-item v-for="m in s.metadata" :key="m.id">
                    <dl v-if="m.property == 'Sentiment'">
                      <h5 class="mb-1">{{m.property}}</h5>
                <span v-for="(v,k) in JSON.parse(m.value)" :key="k">
                        <b-badge v-if="v=='NEGATIVE'" variant="warning">{{v}}</b-badge>
                        <b-badge v-else-if="v=='POSITIVE'" variant="success">{{v}}</b-badge>
                        <b-badge v-else variant="light">{{v}}</b-badge>
                      </span>
                    </dl>

                <dl v-if="m.property == 'NamedEntities' && JSON.parse(m.value).length >0">
                      <h5 class="mb-1">{{m.property}}</h5>

                      <b-card-group deck class="mb-3">
                  <b-card
                    header-bg-variant="info"
                    header-text-variant="white"
                    border-variant="light"
                    :header="entity.text"
                    class="text-center"
                    v-for="entity in JSON.parse(m.value)" :key="entity.id"
                    style="max-width: 280px;">

                    <b-card-text>
                      <dl>
                      <dd v-if="entity.source">
                        <small>Source&nbsp;</small>
                        <span>{{entity.source}}</span>
                      </dd>
                      <dd>
                        <small>Category&nbsp;</small>
                        <span v-if="entity.category">{{entity.category}}</span>
                        <span v-if="entity.subCategory"> // {{entity.subCategory}}</span>
                      </dd>
                      <dd>
                        <small>Confidence&nbsp;</small>
                        <span v-if="entity.confidenceScore">{{entity.confidenceScore}}</span>
                      </dd>
                    </dl>

                    </b-card-text>
                  </b-card>

                </b-card-group>


                    </dl>

                    <dl v-if="m.property == 'SemanticTags' && JSON.parse(m.value).length >0">
                          <h5 class="mb-1">{{m.property}}</h5>

                          <b-card-group deck class="mb-3">
                      <div v-for="st in JSON.parse(m.value)" :key="st.id">
                      <b-card
                        header-bg-variant="info"
                        header-text-variant="white"
                        border-variant="light"
                        :header="ek"
                        class="text-center"
                        v-for="(ev, ek) in st" :key="ek"
                        style="max-width: 280px;">


                        <b-card-text>
                            {{ev}} 
                        </b-card-text>
                      </b-card>
                      </div>

                    </b-card-group>
                    </dl>

                    <dl v-if="m.property == 'Temponyms' && JSON.parse(m.value).length >0">
                      <h5 class="mb-1">{{m.property}}</h5>

                      <b-card-group deck class="mb-3">
                  <b-card
                    header-bg-variant="info"
                    header-text-variant="white"
                    border-variant="light"
                    :header="temponym.value"
                    class="text-center"
                    v-for="temponym in JSON.parse(m.value)" :key="temponym.id"
                    style="max-width: 280px;">

                    <b-card-text>
                      <dl>
                      <dd>
                        <small>Source&nbsp;</small>
                        <span v-if="temponym.source">{{temponym.source}}</span>
                      </dd>
                      <dd v-if="temponym.type">
                        <small>Type&nbsp;</small>
                        <span>{{temponym.type}}</span>
                      </dd>
                      <dd v-if="temponym.text">
                        <small>Text&nbsp;</small>
                        <span>{{temponym.text}}</span>
                      </dd>
                    </dl>

                    </b-card-text>
                  </b-card>

                </b-card-group>
                    </dl>


                </b-list-group-item>
                </b-list-group>

            </b-tab>

          </b-tabs>

      </b-tab>

    </b-tabs>

  </div>
</template>

<script>
export default {
  name: 'RenderSentences',
  props: ['sentences', 'ut'],
  computed: {
  }
}
</script>

<style scoped>
  .sentence {
    min-height: 400px;
  }
</style>
